import React, { useEffect, useRef } from "react";
import { useConsent } from "../utils/consent";
import { canShowAds } from "../config/features";

const HilltopAd = ({ scriptSrc, width = 300, height = 250 }) => {
  const adRef = useRef(null);
  const scriptAdded = useRef(false);
  const consent = useConsent();
  const adsAllowed = canShowAds(consent);

  useEffect(() => {
    if (!adsAllowed) return; // no advertising consent -> never load the ad script
    if (!scriptSrc) {
      console.warn("HilltopAd: scriptSrc prop is required");
      return;
    }
    if (scriptAdded.current) return;
    if (!adRef.current) return;

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.async = true;
    script.referrerPolicy = "no-referrer-when-downgrade";

    adRef.current.appendChild(script);
    scriptAdded.current = true;

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      scriptAdded.current = false;
    };
  }, [scriptSrc, adsAllowed]);

  if (!adsAllowed) return null;

  return (
    <div
      ref={adRef}
      style={{
        minHeight: `${height}px`,
        minWidth: `${width}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "1rem auto",
      }}
    />
  );
};

export default HilltopAd;
